import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import usersSlice from '../reducers/users.slice'

const persistConfig = {
  key: 'usersSlice',
  storage,
}

export const persistedUsersReducer = persistReducer(persistConfig, usersSlice)